export const TeacherGrade = {
  Junior: 'Junior',
  Middle: 'Middle',
  Senior: 'Senior'
} as const

export type TeacherGrade = (typeof TeacherGrade)[keyof typeof TeacherGrade]
